import PropTypes from 'prop-types';
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

/**** Components ****/
import Login from "../pages/auth/Login";
import { savePostLoginRedirect } from "../utils/authentication/authLibrary";

const ProtectedRoute = ({ children }) => {
    const location = useLocation();
    const { isAuthenticated, isLoggedIn } = useSelector((state) => state.auth);

    if (isAuthenticated && isLoggedIn) {
        return children;
    }

    // Keep return URL so successful login restores the same page.
    const returnPath = `${location.pathname}${location.search || ""}`;
    savePostLoginRedirect(returnPath);

    // Prefer dedicated /login route so hard-refresh and bookmarks stay consistent.
    if (location.pathname !== "/login") {
        return <Navigate to="/login" replace state={{ from: returnPath }} />;
    }

    return <Login />;
}

ProtectedRoute.propTypes = {
    children: PropTypes.node.isRequired,
};

export default ProtectedRoute;
